<template>
  <div class="modern-form">
    <div class="form-container">
      <div class="section-header">
        <h2 class="section-title">Password Settings</h2>
      </div>
      <v-form
        ref="form"
        @submit.prevent="submitForm"
        v-model="isFormValid"
        lazy-validation
        class="">
      
      <div class="form-row">
        <div class="form-group">
          <v-text-field
            v-model="form.old_password"
            label="Current Password"
            :rules="[rules.required, rules.max50]"
            class="line-input custom-filled"
            dense
            hide-details="auto"
            required
            type="password" />
        </div>
        <div class="form-group"></div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <v-text-field
            v-model="form.new_password"
            label="New Password"
            :rules="[rules.required, rules.pass_all, rules.max50]"
            class="line-input custom-filled"
            dense
            hide-details="auto"
            required
            type="password" />
        </div>
        <div class="form-group"></div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <v-text-field
            v-model="form.repeat_password"
            label="Repeat New Password"
            :rules="[rules.required, rules.pass_all, rules.max50, passwordConfirmationRule]"
            class="line-input custom-filled"
            dense
            hide-details="auto"
            required
            type="password" />
        </div>
        <div class="form-group"></div>
      </div>

      <div class="form-actions">
        <v-btn
          class="btn-primary"
          @click="submitForm"
          :disabled="!isFormValid"
          :loading="isSubmitting">
          Save
        </v-btn>
      </div>
    </v-form>
    </div>
  </div>
</template>
<script>
import DataService from '../../../_services/DataService';
import ValidateService from '../../../_services/ValidateService';

export default {
  data() {
    return {
      isFormValid: false,
      isSubmitting: false,
      form: {
        old_password: '',
        new_password: '',
        repeat_password: '',
      },
      rules: ValidateService.validators,
    };
  },
  computed: {
    passwordConfirmationRule() {
      return () => (this.form.new_password === this.form.repeat_password) || 'Passwords must match';
    },
  },
  methods: {
    async submitForm() {
      try {
        if (this.$refs.form.validate()) {
          this.isSubmitting = true;
          const payload = {
            currentPassword: this.form.old_password,
            newPassword: this.form.new_password,
          };

          const response = await DataService.updateUserPassword(payload);
          if (response.status === 200) {
            this.$root.$emit('raise_alert', { color: 'success', text: 'Password updated successfully' });
            this.form = {
              old_password: '',
              new_password: '',
              repeat_password: '',
            };
            this.$refs.form.resetValidation();
          } else {
            this.$root.$emit('raise_alert', { color: 'error', text: response.data || 'Something went wrong.' });
          }
        }
      } catch (err) {
        this.$root.$emit('raise_alert', { color: 'error', text: 'Something went wrong.' });
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/scss/variables.scss';

// Form-specific color variables
$section-title-color: #1f2937;
</style>
